import {
  Button,
  Dialog,
  DialogContent,
  Typography,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { RouteLink } from "../common/styles";
import { useShouldShowAccountVerificationBanner } from "@/components/banners/AccountVerificationBanner";
import { getFromStorage, setToStorage } from "@/utils/localStorageUtils";
import DialogCloseButton from "@/ui/dialogs/DialogCloseButton";

const SEEN_STORAGE_KEY = "hasSeenVerificationRequiredModal";

export default function AccountVerificationModal() {
  const shouldShow = useShouldShowAccountVerificationBanner();
  const [open, setOpen] = useState(false);

  const theme = useTheme();

  useEffect(() => {
    if (shouldShow && !getFromStorage(SEEN_STORAGE_KEY)) {
      setOpen(true);
    }
  }, [shouldShow]);

  const handleClose = () => {
    setToStorage(SEEN_STORAGE_KEY, "true");
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth={true}
      keepMounted={false}
    >
      <DialogCloseButton onClick={handleClose} />
      <DialogContent
        sx={{
          p: 5,
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <img
          loading="lazy"
          decoding="async"
          src={`/warning${theme.palette.mode === "dark" ? "-dark" : ""}.svg`}
          alt="verification required"
          width={100}
          height={100}
        />
        <Typography variant="h5" fontWeight="bold" textAlign="center">
          Your account requires verification
        </Typography>
        <Typography
          variant="body1"
          fontWeight="bold"
          textAlign="center"
          sx={{ textWrap: "balance" }}
        >
          Please complete verification to keep your service active.
        </Typography>
        <Typography
          variant="body2"
          textAlign="center"
          sx={{ textWrap: "balance" }}
        >
          If verification is not completed, or activity in flagged target
          categories continues or increases, your proxies may be limited and
          your account may be temporarily suspended.
        </Typography>
        <RouteLink to="/accountverification" sx={{ mt: 4 }}>
          <Button
            variant="contained"
            data-testid="verify-account-button"
            onClick={handleClose}
          >
            Verify Account
          </Button>
        </RouteLink>
      </DialogContent>
    </Dialog>
  );
}
